module.exports = __webpack_public_path__ + "img/result_1.d0e78459.png";